import axios from "axios";

import {
  IWebSecurityRequest,
  IWebSecurityResponse,
} from "models/WebSecurity/webSecurity.model";
import { setMBB } from "redux/slices/WebSecuritySlice";
import { store } from "redux/store";
import { createRSAKey } from "utils/CryptOperations/Rsa-encrypt";

export const WebSecurity = async (): // webSecParams: IWebSecurityRequest
Promise<IWebSecurityResponse> => {
  const reqData = serviceWebSecurityModelCreator(); //webSecParams

  try {
    const { data } = await axios.post<IWebSecurityResponse>("/Token", reqData);
    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    // store.dispatch(setMBB(webSecParams.Mbb));

    createRSAKey(data.PblExponet, data?.PblModulus);
    return data;
  } catch (error) {
    console.log(`WEBSECURITY_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceWebSecurityModelCreator = () => {
  //webSecParams: IWebSecurityRequest
  let req = {
    // Mbb: webSecParams.Mbb,
    // ChannelKey: "true",
    // Language: "tr-TR",
    UserAgent:
      "Mozilla/5.0 (Linux; Android 11; SM-A307FN Build/RP1A.200720.012; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/129.0.6668.100 Mobile Safari/537.36",
    NextTransactionUrl: "ModAuthWebSecurity",
  };

  return req;
};
